import templateUrl from './taskTemplatesSidebarComponent.html';

class taskTemplatesSidebarCtrl {
  constructor($scope, $uibModal, TaskTemplatesService, ShiftTasksReactBridge) {
    'ngInject';

    Object.assign(this, { $scope, $uibModal, TaskTemplatesService, ShiftTasksReactBridge });
  }

  $onInit() {
    this.$scope.$watch('ctrl.open', () => {
      if (this.open) {
        this.loadTemplates();
      }
    });

    this.$scope.$on('socket:taskTemplate:sync', () => {
      if (this.open) {
        this.loadTemplates();
      }
    });

    this.isAddTemplateModalOpen = false;
    this.isEditTemplateModalOpen = false;
    this.selectedTemplate = null;
  }

  get taskTemplates() {
    return this.TaskTemplatesService.allTemplates;
  }

  close() {
    this.open = false;
  }

  async loadTemplates() {
    this.templatesLoading = true;
    await this.TaskTemplatesService.loadTemplates();
    this.templatesLoading = false;
  }

  onAddTaskModalClose = () => {
    this.isAddTemplateModalOpen = false;
    this.selectedTemplate = null;
  };

  onEditTaskModalClose = () => {
    this.isEditTemplateModalOpen = false;
    this.selectedTemplate = null;
  };

  createTaskTemplate() {
    this.isAddTemplateModalOpen = true;
  }

  copyTaskTemplate = (sourceTemplate) => {
    this.selectedTemplate = sourceTemplate;
    this.isAddTemplateModalOpen = true;
  };

  editTaskTemplate = (sourceTemplate) => {
    this.selectedTemplate = sourceTemplate;
    this.isEditTemplateModalOpen = true;
  };

  async viewTaskTemplate(template) {
    const self = this;

    await this.$uibModal.open({
      template: `
        <view-task-template-sidebar 
          modal="modal" 
          template-id="templateId" 
          copy-task-template="copyTaskTemplate(sourceTemplate)"
          edit-task-template="editTaskTemplate(sourceTemplate)"
        ></view-task-template-sidebar>
      `,
      backdrop: 'static',
      size: '620',
      controller($scope, $uibModalInstance) {
        'ngInject';

        $scope.copyTaskTemplate = self.copyTaskTemplate;
        $scope.editTaskTemplate = self.editTaskTemplate;
        $scope.modal = $uibModalInstance;
        $scope.templateId = template.id;
      },
    });
  }
}

export default {
  templateUrl,
  controller: taskTemplatesSidebarCtrl,
  controllerAs: 'ctrl',
  bindings: {
    open: '=',
    templateId: '<',
  },
};
